import { memo } from 'react';
import type { IconProps } from './types';

const PendingClockIcon = ({ iconLabel, color }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.803"
        height="18.802"
        viewBox="0 0 18.803 18.802"
        data-icon={iconLabel}
        color={color}
    >
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_3875"
                    data-name="Rectangle 3875"
                    width="18.803"
                    height="18.802"
                    fill="none"
                />
            </clipPath>
        </defs>
        <g id="Group_3215" data-name="Group 3215" transform="translate(0 0)">
            <g
                id="Group_3214"
                data-name="Group 3214"
                transform="translate(0 0)"
                clipPath="url(#clip-path)"
            >
                <path
                    id="Path_1877"
                    data-name="Path 1877"
                    d="M3.493,11.294a1.208,1.208,0,1,0-1.948,1.428,9.357,9.357,0,0,0,2.1,2.078,1.208,1.208,0,1,0,1.408-1.963,6.969,6.969,0,0,1-1.563-1.543"
                    transform="translate(0.272 2.243)"
                    fill="currentColor"
                />
                <path
                    id="Path_1878"
                    data-name="Path 1878"
                    d="M2.5,9.321a7.176,7.176,0,0,1-.088-1.115A6.958,6.958,0,0,1,2.5,7.122,1.208,1.208,0,0,0,.114,6.748,9.374,9.374,0,0,0,0,8.206,9.542,9.542,0,0,0,.118,9.7a1.208,1.208,0,0,0,1.191,1.017A1.313,1.313,0,0,0,1.5,10.7a1.208,1.208,0,0,0,1-1.384"
                    transform="translate(0 1.189)"
                    fill="currentColor"
                />
                <path
                    id="Path_1879"
                    data-name="Path 1879"
                    d="M2.511,5.515a1.2,1.2,0,0,0,.977-.5,6.972,6.972,0,0,1,1.558-1.55A1.208,1.208,0,1,0,3.632,1.51,9.386,9.386,0,0,0,1.536,3.6a1.208,1.208,0,0,0,.975,1.919"
                    transform="translate(0.271 0.266)"
                />
                <path
                    id="Path_1880"
                    data-name="Path 1880"
                    d="M8.315,0H8.3c-.017,0-.031.01-.05.01S8.219,0,8.2,0C7.78.019,7.275.034,6.816.1A1.208,1.208,0,0,0,6.99,2.5a1.285,1.285,0,0,0,.179-.013,7.035,7.035,0,0,1,1.019-.075H8.2c.016,0,.028-.008.043-.008s.027.008.042.008a6.986,6.986,0,0,1,0,13.971c-.014,0-.028.008-.042.01s-.03-.01-.046-.01h0a7.276,7.276,0,0,1-1.028-.074A1.207,1.207,0,0,0,6.813,18.7a9.36,9.36,0,0,0,1.361.1H8.2c.017,0,.031-.008.048-.01s.033.01.051.01h.014a9.4,9.4,0,0,0,0-18.8"
                    transform="translate(1.201 0)"
                />
                <path
                    id="Path_1881"
                    data-name="Path 1881"
                    d="M6.781,12.183l2.773-1.457a1.211,1.211,0,0,0,.647-1.07V4.862a1.208,1.208,0,0,0-2.417,0V8.927L5.658,10.044a1.208,1.208,0,0,0,1.123,2.139"
                    transform="translate(1.041 0.759)"
                />
            </g>
        </g>
    </svg>
);

export default memo(PendingClockIcon);
